import React, { useCallback, useEffect, useState } from 'react';
import providersContext from '../contexts/providers';
import { readProviders as readProvidersApi } from '../api/providers';
import ProgressBackdrop from '../../preorder/components/ProgressBackdrop';
import firebase from '../../preorder/services/firebase';

const { Provider } = providersContext;
const path = `/${process.env.REACT_APP_MODE}/providers/data`;
const providersRef = firebase.database().ref(path);

export default (WrappedComponent) => () => {
  const [providers, setProviders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    providersRef.on('value', (snapshot) => {
      const data = snapshot.val();
      setProviders(data || []);
      setIsLoading(false);
    }, (e) => {
      setIsLoading(false);
      console.log(e.message);
    });
    return () => { providersRef.off('value'); };
  }, [setProviders]);

  const readProviders = useCallback(async () => {
    try {
      setIsLoading(true);

      const providersResult = await readProvidersApi();
      const { data, status } = providersResult || {};
      const { providers: dataProviders } = data || {};

      if (status !== 'success') throw new Error('load providers failed');

      return dataProviders;
    } catch (e) {
      console.log(e.message);
    } finally {
      setIsLoading(false);
    }

    return [];
  }, [setIsLoading]);

  return (
    <Provider value={{
      readProviders,
      providers,
      isLoading,
    }}
    >
      <WrappedComponent />
      <ProgressBackdrop isShow={isLoading} />
    </Provider>
  );
};
